import { render } from "./langSwitch.vue?vue&type=template&id=66cfe3e2&scoped=true"
import script from "./langSwitch.vue?vue&type=script&lang=js"
export * from "./langSwitch.vue?vue&type=script&lang=js"

import "./langSwitch.vue?vue&type=style&index=0&id=66cfe3e2&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cfe3e2"]])

export default __exports__